import * as React from 'react';
import { Switch } from 'Src/components/Switch/Switch';

interface Props {
  isError: boolean;
  email: string;
  password: string;
  isAgree: boolean;
  onEmailChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onAgreementChange: () => void;
  onSubmit: (event: React.SyntheticEvent) => void;
  onCloseClick: () => void;
}

export function TerminatingForm(props: Props) {
  const {
    onCloseClick,
    onSubmit,
    onAgreementChange,
    onEmailChange,
    onPasswordChange,
    email,
    password,
    isAgree,
    isError
  } = props;
  const submitDisabled = email === '' || password === '' || !isAgree;

  return (
    <div className="upSubscriptionAuthForm">
      {isError && <div className="upSubscriptionAuthError">Incorrect email or password.</div>}
      <p className="upSubscriptionAuthIntro">
        Closing your account removes your access to every linked school and role. Confirm your credentials to continue
        to the final warning.
      </p>

      <div className="upSubscriptionAuthField">
        <label htmlFor="login_email">Your email</label>
        <input type="email" value={email} onChange={onEmailChange} id="login_email" />
      </div>

      <div className="upSubscriptionAuthField">
        <label htmlFor="login_password">Your password</label>
        <input type="password" id="login_password" value={password} onChange={onPasswordChange} />
      </div>

      <div className="upSubscriptionAgreement">
        <Switch
          name={'terminating_form_switch'}
          value={isAgree}
          text={'I understand that closing my Squad In Touch account is permanent and cannot be undone.'}
          onChange={onAgreementChange}
        />
      </div>

      <div className="upSubscriptionAuthActions">
        <button type="button" className="upProfileBtn upProfileBtnSecondary" onClick={onCloseClick}>
          Cancel
        </button>
        <button type="submit" className="upProfileBtn upProfileBtnDanger" onClick={onSubmit} disabled={submitDisabled}>
          Continue
        </button>
      </div>
    </div>
  );
}
